export enum BudgetSecondaryNavLink {
    SPENDSMART = 'SPENDSMART',
    TRANSACTIONS = 'Transactions',
    SETTINGS = 'Settings'
}
